export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to

  if (shouldRedirect(path)) {
    const nextPath = getNextPath(path)
    const nextRoute = { path: nextPath, query, hash }
    return navigateTo(nextRoute, { redirectCode: 301 })
  }
})

function shouldRedirect(path) {
  const isLowerCase = path === path.toLowerCase()
  const hasTrailingSlash = path.endsWith('/')
  const includeRader = path.includes('/rader')
  const includeGeorgia = path.includes('/4/georgia/')
  const includeAzerbaijan = path.includes('/4/azerbaijan/')
  const includeArmenia = path.includes('/9/armenia/')
  const includeIndiaCochin = path.includes('/3/india/cochin')

  return !(isLowerCase && hasTrailingSlash && !includeRader && !includeGeorgia && !includeAzerbaijan && !includeArmenia && !includeIndiaCochin)
}

function getNextPath(path) {
  let nextPath = path.toLowerCase()
  if (!path.endsWith('/')) nextPath += '/'
  if (path.includes('/rader')) nextPath = nextPath.replace('/rader', '/radar')
  if (path.includes('/4/georgia/')) nextPath = nextPath.replace('/4/georgia/', '/5/georgia/')
  if (path.includes('/4/azerbaijan/')) nextPath = nextPath.replace('/4/azerbaijan/', '/5/azerbaijan/')
  if (path.includes('/9/armenia/')) nextPath = nextPath.replace('/9/armenia/', '/5/armenia/')
  if (path.includes('/3/india/cochin/')) nextPath = nextPath.replace('/3/india/cochin/', '/3/india/kochi/')
  return nextPath
}
